import { Component, OnInit } from '@angular/core';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import { RoadAssistanceContextService } from '@core/services/context/road-assistance-context.service';
import { PoliciesHelperService } from '@core/services/core/policies-helper.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ICT_PRICING_ROUTING_PATH } from '@modules/client-area/models/ICTPricing';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';
import { UrlHelper } from '@core/services/helpers/url-helper.service';

@Component({
  selector: 'app-mapfre-home-tabs',
  templateUrl: './mapfre-home-tabs.component.html',
  styleUrls: ['./mapfre-home-tabs.component.scss'],
  animations: [
    trigger('slideMoreOptions', [
      state('false', style({
        visibility: 'hidden'
      })),
      state('true', style({
        visibility: 'visible'
      })),
      transition('true <=> false', animate('600ms ease-in-out'))
    ])
  ]
})
export class MapfreHomeTabsComponent implements OnInit {
  userHasCarPolicies = false;
  showMoreOptions = false;

  moreOptions = [
    {
      id: 'new-product',
      text: 'CLIENT_AREA.CA_MENU.NEW_PRODUCT',
      icon: 'assets/images/menu/new-product.svg',
      handler: () => this.onNavTo(ICT_PRICING_ROUTING_PATH),
      styles: 'more-options--option color-white'
    },
    {
      id: 'offices',
      text: 'CLIENT_AREA.CA_MENU.OFFICES',
      icon: 'assets/images/menu/offices.svg',
      handler: () => this.onNavTo('locator/services-view'),
      styles: 'more-options--option color-white'
    },
    {
      id: 'medical-center',
      text: 'CLIENT_AREA.CA_MENU.MEDICAL_CENTER',
      icon: 'assets/images/menu/medical-centers.svg',
      handler: () => this.onNavTo('locator/medical-center/search'),
      styles: 'more-options--option color-white'
    },
    {
      id: 'garages',
      text: 'CLIENT_AREA.CA_MENU.GARAGES',
      icon: 'assets/images/menu/garages.svg',
      handler: () => this.onNavTo('locator/garage/search'),
      styles: 'more-options--option color-white'
    }
  ];

  constructor(
    private nav: NavigationHelper,
    private roadAssistanceCtx: RoadAssistanceContextService,
    private policiesHelper: PoliciesHelperService,
    private mmobileHelper: MMobileHelperService,
    private url: UrlHelper
  ) {}

  ngOnInit() {
    this.checkNumberOfCarPolicies();
  }

  onOpenTeCuidamos() {
    return this.nav.toNew('tecuidamos/tc-transition');
  }

  onOpenAllProducts() {
    this.nav.goHomePage({ queryParams: { products: true } });
  }

  onToggle() {
    this.showMoreOptions = !this.showMoreOptions;
  }

  private checkNumberOfCarPolicies() {
    this.policiesHelper.checkUserHasCarPolicies$().subscribe(state => {
      if (state) {
        this.moreOptions.push({
          id: 'road-assistance',
          text: 'CLIENT_AREA.CA_MENU.ROAD_ASSISTANCE',
          icon: 'assets/images/menu/road-assistance.svg',
          handler: () => this.onRoadAssistance(),
          styles: 'more-options--option color-primary'
        });
      }
    });
  }

  private onNavTo(route: string){
    this.nav.toNew(route);
    this.onToggle();
  }

  private onRoadAssistance() {
    this.roadAssistanceCtx.initializeRoadAssistanceFlow();
    this.onToggle();
  }
}
